module.exports = __webpack_public_path__ + "static/media/felveteli-epuulet-reszleges-bontasa-dorog.a162d14f.jpg";